import { type Table } from '@tanstack/react-table'
import { SearchIcon } from 'lucide-react'
import React from 'react'

import { TextInput } from 'slab'

export const TanstackTableGlobalSearch = <T, >({
  table,
  placeholder,
}: {
  table: Table<T>;
  placeholder: string;
}) => {
  return (
    <TextInput
      leadingIcon={SearchIcon}
      onChange={(event) => {
        table.setGlobalFilter(event.target.value)
      }}
      placeholder={placeholder}
      value={(table.getState().globalFilter as string) ?? ''}
    />
  )
}
